/**
 * 项目信息组件
 */
import React from 'react';
import { Typography, Row, Col, Tag, Space } from 'antd';
import {
  CalendarOutlined,
  SyncOutlined,
  CheckCircleOutlined,
  ExclamationCircleOutlined,
  PauseCircleOutlined
} from '@ant-design/icons';
import type { ProjectOverviewData } from '../../services/dashboardService';

const { Text, Title } = Typography;

interface ProjectInfoProps {
  project: ProjectOverviewData;
  isMobile?: boolean;
}

// 项目状态配置
const STATUS_CONFIG: Record<string, { color: string; icon: React.ReactNode; text: string }> = {
  '进行中': { color: 'processing', icon: <SyncOutlined spin />, text: '进行中' },
  '已完成': { color: 'success', icon: <CheckCircleOutlined />, text: '已完成' },
  '待开始': { color: 'default', icon: <ExclamationCircleOutlined />, text: '待开始' },
  '已暂停': { color: 'warning', icon: <PauseCircleOutlined />, text: '已暂停' }
};

const ProjectInfo: React.FC<ProjectInfoProps> = ({
  project,
  isMobile = false
}) => {
  const statusConfig = STATUS_CONFIG[project.status] || STATUS_CONFIG['待开始'];

  const formatDate = (dateStr?: string) => {
    if (!dateStr) return '-';
    return dateStr.split('T')[0];
  };

  return (
    <div style={{ marginBottom: isMobile ? 16 : 24 }}>
      <Title level={5} style={{ marginBottom: 16, fontSize: isMobile ? 14 : 16 }}>
        项目信息
      </Title>
      
      <Row gutter={[16, isMobile ? 8 : 12]}>
        <Col xs={12} sm={12} md={6}>
          <Space size={4}>
            <CalendarOutlined style={{ color: '#1677ff' }} />
            <Text type="secondary" style={{ fontSize: isMobile ? 12 : 13 }}>开始日期</Text>
          </Space>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14 }}>
              {formatDate(project.startDate)}
            </Text>
          </div>
        </Col>
        
        <Col xs={12} sm={12} md={6}>
          <Space size={4}>
            <CalendarOutlined style={{ color: '#52c41a' }} />
            <Text type="secondary" style={{ fontSize: isMobile ? 12 : 13 }}>结束日期</Text>
          </Space>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14 }}>
              {formatDate(project.endDate)}
            </Text>
          </div>
        </Col>
        
        <Col xs={12} sm={12} md={6}>
          <Text type="secondary" style={{ fontSize: isMobile ? 12 : 13 }}>项目状态</Text>
          <div style={{ marginTop: 4 }}>
            <Tag color={statusConfig.color} icon={statusConfig.icon}>
              {statusConfig.text}
            </Tag>
          </div>
        </Col>
        
        <Col xs={12} sm={12} md={6}>
          <Text type="secondary" style={{ fontSize: isMobile ? 12 : 13 }}>数据记录</Text>
          <div>
            <Text style={{ fontSize: isMobile ? 13 : 14 }}>
              {project.teamSize} 条
            </Text>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ProjectInfo;
